export default () => {
  $('[data-toggle="tooltip"]').tooltip()
};
